export const STORAGE_KEYS = {
  USER: 'user',
  PROFILE_PICTURE: 'profilePicture',
  IS_RELOADING: 'isReloading',
};
